import { Component, OnInit } from '@angular/core';
import { CoreUtilsModule } from '../../../../shared/core-utils';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { StudyEntryService } from '../../../../shared/study/service/study-entry.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-edit-entry-type',
    standalone: true,
    imports: [
        CoreUtilsModule,
        FormsModule,
        NgSelectModule,
        TranslateModule
    ],
    templateUrl: './edit-entry-type.component.html',
    styleUrl: './edit-entry-type.component.scss'
})
export class EditEntryTypeComponent implements OnInit {

    entryTypes: any[] = [];
    selectedEntryTypeId: number;

    constructor(private studyEntryService: StudyEntryService,
                private activeModal: NgbActiveModal,
    ) { }

    ngOnInit(): void {
        this.studyEntryService.getEntryTypes().toPromise().then(entryTypes => {
            this.entryTypes = entryTypes;
            this.selectedEntryTypeId = this.entryTypes[0].id;
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }

    dismiss() {
        this.activeModal.dismiss();
    }

    accept() {
        this.activeModal.close(this.selectedEntryTypeId);
    }
}
